import { LoadingIndicator } from "@/components/resources/components/ui/LoadingIndicator"

export function LoadingIndicatorBox({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={`flex justify-center items-center w-full h-full min-h-[calc(100vh-300px)] flex-grow ${className || ""}`}
      {...props}
    >
      <LoadingIndicator />
    </div>
  )
}
